import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4055a92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["value", "id", "name"]
const _hoisted_3 = { class: "checkbox-group-items__item-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox-group-items", { stacked: _ctx.variant === 'stacked' }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionItems, (option, index) => {
      return (_openBlock(), _createElementBlock("label", {
        key: `${_ctx.name}${index}`,
        class: "checkbox-group-items__item mb-0 text-mild",
        for: `option-${_ctx.name}-${option.value}`
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "d-none",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedItemsValue) = $event)),
          value: option.value,
          id: `option-${_ctx.name}-${option.value}`,
          name: _ctx.name
        }, null, 8, _hoisted_2), [
          [_vModelCheckbox, _ctx.checkedItemsValue]
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createVNode(_component_FeatherIcon, {
            icon: "square",
            size: "18"
          }, null, 512), [
            [_vShow, !option.checked]
          ]),
          _createTextVNode(),
          _withDirectives(_createVNode(_component_FeatherIcon, {
            icon: "check-square",
            size: "18",
            class: "text-blue"
          }, null, 512), [
            [_vShow, option.checked]
          ]),
          _createTextVNode(),
          _createElementVNode("span", {
            class: _normalizeClass(["ml-1 text-size-12", { 'text-blue': option.checked }])
          }, _toDisplayString(option.text), 3)
        ])
      ], 8, _hoisted_1))
    }), 128))
  ], 2))
}